import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { formatDate } from "../../../../common/Common";
import { setTransactionsHeaders } from "../../../../store/actions/transactionsHeadersActions";
import { useDispatch } from "react-redux";

interface IErrorTransacitonsHeader {
	clientsDDL: any,
	accountantDDL: any,
	// paymentMethodDDL: any,
	onAccountantSelectionChangeHandler: (value: any) => void
	setStateRunGetListAPICall: (value: boolean) => void
}

export const ErrorTransacitonsHeader: React.FC<
	IErrorTransacitonsHeader
> = ({ accountantDDL, onAccountantSelectionChangeHandler, clientsDDL, setStateRunGetListAPICall }) => {
	const dispatch = useDispatch()
	const onClientSelectionChnageHandler = (event: any) => {
		setStateRunGetListAPICall(false)
		dispatch(setTransactionsHeaders({ client: event.value }));
		// dispatch(setTransactionsHeaders({ client: event.value }));
	}
	const onClientTypeSelectionChnageHandler = (event: any) => {
		setStateRunGetListAPICall(false)
		dispatch(setTransactionsHeaders({ clientType: event.value }));
	}
	const onTypeSelectionChnageHandler = (event: any) => {
		setStateRunGetListAPICall(false)
		dispatch(setTransactionsHeaders({ type: event.value }));
	}
	const onDateAppliesOnSelectionChnageHandler = (event: any) => {
		setStateRunGetListAPICall(false)
		dispatch(setTransactionsHeaders({ dateAppliesOn: event.value }));
	}
	const onTransactionMethodSelectionChnageHandler = (event: any) => {
		setStateRunGetListAPICall(false)
		dispatch(setTransactionsHeaders({ transactionMethod: event.value }));
	}
	const onSatrtDateSelectionChnageHandler = (date: any) => {
		setStateRunGetListAPICall(false)
		let dateFormat = formatDate(date.target.value)
		dispatch(setTransactionsHeaders({ startDate: dateFormat }));

	}
	const onEndDateSelectionChnageHandler = (date: any) => {
		setStateRunGetListAPICall(false)
		let dateFormat = formatDate(date.target.value)
		dispatch(setTransactionsHeaders({ endDate: dateFormat }));
	}
	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"accountant"}
						items={accountantDDL ?? []}
						selectedItem={"all"}
						label={"Accountant Name"}
						testId={"cleint-ddl"}
						onSelectionChangeHandler={onAccountantSelectionChangeHandler}
					/>
				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"client"}
						items={clientsDDL ?? []}
						selectedItem={"all"}
						label={"Client Name"}
						testId={"cleint-ddl"}
						onSelectionChangeHandler={onClientSelectionChnageHandler}
					/>
				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"clientType"}
						items={[
							{
								label: "All",
								value: "all",
							},
							{
								label: "Test",
								value: 200,
							},
							{
								label: "Live",
								value: 100,
							}
						]}
						label={"Client Type"}
						testId={"client-type"}
						selectedItem={"all"}
						onSelectionChangeHandler={onClientTypeSelectionChnageHandler}
					/>


				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"type"}
						items={[
							{
								label: "All",
								value: "all",
							},
							{
								label: "Invoice",
								value: 200,
							},
							{
								label: "CRA",
								value: 100,
							},
							{
								label: "RQ",
								value: 100,
							},
							{
								label: "Payroll",
								value: 100,
							},
							{
								label: "EHT Ontario",
								value: 100,
							},
							{
								label: "Employee Advance",
								value: 100,
							},
							{
								label: "Collection Voucher",
								value: 100,
							},
							{
								label: "Payment Voucher",
								value: 100,
							},
						]}
						label={"Type"}
						testId={"type"}
						selectedItem={"all"}
						onSelectionChangeHandler={onTypeSelectionChnageHandler}
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					{/* <Grid
						size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }} sx={{paddingTop:"6px"}}
					>
						<span style={{
							fontSize: "0.875rem",
							fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
							fontWeight: 500,
							letterSpacing: "0.00714em",
							color: "rgba(0, 0, 0, 0.6)"
						}}>Date In</span>
					</Grid> */}
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					>
						<EnhancedDropDownRHFWithLabel
							selectName={"transactionMethod"}
							items={[
								{
									label: "All",
									value: "all",
								},
								{
									label: "Direct Deposit",
									value: 100,
								},
								{
									label: "Wire Transfer",
									value: 200,
								},
							]}
							label={"Transaction Method"}
							testId={"transaction-method"}
							selectedItem={"all"}
							onSelectionChangeHandler={onTransactionMethodSelectionChnageHandler}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					>
						<EnhancedDropDownRHFWithLabel
							selectName={"dateAppliesOn"}
							items={[
								{
									label: "All",
									value: "all",
								},
								{
									label: "Craeted On",
									value: 100,
								},
								{
									label: "Pay Period End Date",
									value: 200,
								},
							]}
							label={"Date Applies On"}
							testId={"date-applies-to"}
							selectedItem={"all"}
							onSelectionChangeHandler={onDateAppliesOnSelectionChnageHandler}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
					{/* <Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}

					>
						<EnhancedDropDownRHFWithLabel
							selectName={"paymentMethod"}
							items={paymentMethodDDL ?? []}
							selectedItem={"all"}
							label={"Payment Method"}
							testId={"payment-method-ddl"}
						// onSelectionChangeHandler={onAccountantSelectionChangeHandler}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid> */}
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					>
						<RHookFormDatePicker
							name="startDate"
							testId="start-date"
							label="Date In"
							// labelPosition={LabelPosition.Top}
							format="M dd, yy"
							onDateSelectionChangeHandler={onSatrtDateSelectionChnageHandler}
						/>
					</Grid>
					<Grid
						size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}
						sx={{ maxWidth: "82px", textAlign: "center", paddingTop: "30px" }}
					>
						<span style={{
							fontSize: "0.875rem",
							fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
							fontWeight: 500,
							letterSpacing: "0.00714em",
							color: "rgba(0, 0, 0, 0.6)",
							// paddingTop:"1.4rem"
						}}>to</span>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
						sx={{
							"& .MuiGrid-root .MuiFormLabel-root": { marginTop: "24px!important", },
						}}
					>
						<RHookFormDatePicker
							name="endDate"
							testId="end-date"
							label=""
							// labelPosition={LabelPosition.Top}
							format="M dd, yy"
							onDateSelectionChangeHandler={onEndDateSelectionChnageHandler}
						/>
					</Grid>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						// onClickHandler={onApplyButtonClickedHandler}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					// onClickHandler={() => setStateRunGetListAPICall(true)}
					/>
				</Grid>

			</Grid>


		</>
	);
};
